import React from 'react'
import classnames from 'classnames'

const EventCardSmallContainer = ({ className, ...rest }) => (
  <article
    className={classnames(
      'relative w-full rounded-lg overflow-hidden bg-gray-800 bg-opacity-40 flex flex-col shadow h-full',
      className
    )}
    {...rest}
  />
)

export default EventCardSmallContainer
